module.exports = __webpack_public_path__ + "static/media/IMG_7578.d6cf68b5.JPG";